// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1486":"dcae850c8eff02bf","5343":"a88fd30891c11dcd","8930":"4970d879a9cc2e17"}[chunkId] + ".css";
};